import { KS_CONTACT, kshetrapalDeveloper, buildFaqs } from "./developer";

const G = "https://shreekshetrapal.in/storage/2025/09";

const industrialPark = {
    slug: "shree-kshetrapal-commercial-industrial-park",
    visibility: "public",
    name: "Shree Kshetrapal Commercial & Industrial Park",
    tagline: "Commercial & Industrial Plots · Bhuj–Anjar Highway",
    category: "commercial",
    typeLabel: "Commercial & Industrial Plots",
    areaLabel: null,
    city: "Bhuj",
    citySlug: "bhuj",
    locality: "Bhuj–Anjar Highway",
    status: "Under Construction",
    priceLabel: null,
    developer: { name: "Shree Kshetrapal Infra LLP" },
    whatsapp: KS_CONTACT.whatsapp,
    phone: KS_CONTACT.phone,
    phoneDisplay: KS_CONTACT.phoneDisplay,
    coverImage: `${G}/industrial-1.webp`,
    hero: {
        image: `${G}/industrial-1.webp`,
        overline: "Commercial & Industrial Plots · Bhuj–Anjar Highway",
        lines: ["Commercial &", "Industrial Park"],
        sub: "Premium, strategically located plots for commercial and industrial use — excellent visibility, connectivity and ready infrastructure on the Bhuj–Anjar highway.",
    },
    sections: [
        {
            type: "overview",
            overline: "Overview",
            title: "Plots engineered for enterprise.",
            paragraphs: [
                "Shree Kshetrapal Commercial and Industrial Park presents premium plots in a strategic highway location, ideal for both business and industrial development.",
                "The layout is smartly planned with highway-facing plots dedicated to commercial use — offering great visibility for shops, showrooms and offices — while interior plots are reserved for industrial purposes, perfect for warehouses, factories and other setups. With excellent road connectivity, a well-organised layout and investment-ready infrastructure, this park is a gateway to long-term growth.",
            ],
            facts: [
                { label: "Status", value: "Under Construction" },
                { label: "Type", value: "Commercial & Industrial Plots" },
                {
                    label: "Address",
                    value:
                        "S.No. 313, Bhuj–Anjar Highway, Shekhpir Cross Road, Bhuj–Kutch",
                },
            ],
        },
        {
            type: "highlights",
            overline: "Highlights",
            title: "Why this park.",
            items: [
                {
                    title: "Highway location",
                    text: "Strategically placed on the Bhuj–Anjar Highway at Shekhpir Cross Road.",
                },
                {
                    title: "Highway-facing commercial plots",
                    text: "High-visibility plots for shops, showrooms and offices.",
                },
                {
                    title: "Industrial plots inside",
                    text: "Interior plots suited to warehouses, factories and other setups.",
                },
                {
                    title: "12–18 m wide roads",
                    text: "Broad internal roads for easy movement of goods and vehicles.",
                },
                {
                    title: "Investment-ready infrastructure",
                    text: "Planned utilities and organised layout from day one.",
                },
                {
                    title: "Planned plantation",
                    text: "Green buffers to keep the park pleasant.",
                },
            ],
        },
        {
            type: "amenities",
            overline: "Facilities",
            title: "Infrastructure that works.",
            note: "Facility list as published by the developer.",
            items: [
                { icon: "ShieldCheck", name: "24/7 Security System", desc: "Round-the-clock security coverage." },
                { icon: "Lock", name: "Security Cabin", desc: "Manned entry-point security." },
                { icon: "Droplets", name: "24×7 Water Supply", desc: "Continuous water infrastructure." },
                { icon: "Trees", name: "Plantation", desc: "Planned greenery across the park." },
                { icon: "LayoutGrid", name: "Dedicated Common Plots", desc: "Shared plots for common use." },
                { icon: "MoveHorizontal", name: "Wide Roads (12–18 m)", desc: "Broad internal road network." },
                { icon: "Store", name: "Commercial Plots", desc: "Highway-facing business plots." },
                { icon: "Warehouse", name: "Industrial Plots", desc: "Interior plots for industry." },
            ],
        },
        {
            type: "plans",
            overline: "Layout Plan",
            title: "The park layout.",
            note: "Plan as published by the developer. Tap the plan to view it full size.",
            items: [
                {
                    label: "Master Layout",
                    image: "https://shreekshetrapal.in/storage/2025/04/test.webp",
                },
            ],
        },
        {
            type: "gallery",
            overline: "Gallery",
            title: "The park in views.",
            caption: "Imagery courtesy of Shree Kshetrapal Infra LLP.",
            images: [
                { src: `${G}/1-1.webp`, caption: "Site view", span: 6 },
                { src: `${G}/2.webp`, caption: "Site view", span: 6 },
                { src: `${G}/3.webp`, caption: "Site view", span: 6 },
                { src: `${G}/4.webp`, caption: "Site view", span: 6 },
            ],
        },
        {
            type: "location",
            overline: "Location",
            title: "Bhuj–Anjar Highway.",
            image: "https://shreekshetrapal.in/storage/2025/02/kshetrapal-map-new-4.jpg",
            addressLines: [
                "S.No. 313, Bhuj–Anjar Highway,",
                "Shekhpir Cross Road, Bhuj–Kutch, Gujarat",
            ],
            mapUrl: "https://maps.app.goo.gl/w7BRezYmT3jfDtPv7",
            landmarks: [
                { name: "Bhuj Railway Station", detail: "9.9 km" },
                { name: "Jubilee Ground", detail: "10.4 km" },
                { name: "Bhuj Bus Station", detail: "11.7 km" },
                { name: "Bhuj Airport", detail: "12.8 km" },
            ],
            note: "Distances as published by the developer. Location map courtesy of the developer.",
        },
        { type: "developer", ...kshetrapalDeveloper },
        buildFaqs("Shree Kshetrapal Commercial & Industrial Park"),
        {
            type: "cta",
            overline: "Connect Directly",
            title: "Talk to the park team.",
            text: "Ask for current plot pricing, availability, payment plans or a site visit — your message goes straight to Shree Kshetrapal Infra LLP. No brokers in between.",
            brochureUrl:
                "https://shreekshetrapal.in/storage/2026/04/Shree-Kshetrapal-Commercial-Industrial-Park.pdf",
        },
    ],
};

export default industrialPark;
